import { render, staticRenderFns } from "./dataForm.vue?vue&type=template&id=957e1780&scoped=true&"
import script from "./dataForm.vue?vue&type=script&lang=js&"
export * from "./dataForm.vue?vue&type=script&lang=js&"
import style0 from "./dataForm.vue?vue&type=style&index=0&id=957e1780&prod&lang=less&scoped=true&"
import style1 from "./dataForm.vue?vue&type=style&index=1&id=957e1780&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957e1780",
  null
  
)

export default component.exports